import useTcpaMemo from "@lgp/shared/react/hooks/useTcpaMemo";
import useTcpaOnClickEventListener from "@lgp/shared/react/hooks/useTcpaOnClickEventListener";
import { useCallback, useContext, useMemo, useRef } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { appContext } from "./components/AppProvider";

function App() {
  const { appState } = useContext(appContext);
  const { isLoaded, content, parentHost, configData } = appState;
  const modalRef = useRef();
  const modalBodyRef = useRef();

  // Memoized content data for the modal.
  const { key, title, replacements } = useMemo(
    function memoizedContent() {
      if (content) {
        return {
          key: content.key,
          title: content.title,
          replacements: {
            Company_Name: configData.companyName,
          },
        };
      }

      return { key: "no-content", title: "" };
    },
    [content, configData]
  );

  const tcpa = useTcpaMemo(content ? content.body : "", replacements);
  const tcpaOnClick = useTcpaOnClickEventListener(parentHost);

  // Callback called when the modal is opened.
  const onOpened = useCallback(
    function onOpened() {
      if (isLoaded && modalRef.current) {
        const modalBody = modalRef.current.getElementsByClassName("modal-body");
        if (modalBody.length > 0) {
          modalBodyRef.current = modalBody[0];

          setTimeout(() => {
            if (content.hash) {
              const targetScroll = modalBodyRef.current.querySelector(
                content.hash
              );
              if (targetScroll) {
                modalBodyRef.current.scrollTop = targetScroll.offsetTop;
              }
            }
          }, 250);
        }
      }
    },
    [isLoaded, content]
  );

  // Callback called when the modal is closed.
  const onClosed = useCallback(function onClosed() {
    window.top.postMessage(
      {
        action: "lgp:tcpa:close",
      },
      "*"
    );

    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }

    window.scrollTo({
      top: 0,
    });
  }, []);

  return (
    <Modal
      isOpen={isLoaded}
      toggle={onClosed}
      onOpened={onOpened}
      onClosed={onClosed}
      size="lg"
      scrollable
      innerRef={modalRef}
      fade={false}
      unmountOnClose={false}
    >
      {title && <ModalHeader toggle={onClosed}>{title}</ModalHeader>}
      <ModalBody>
        <div key={key} onClick={tcpaOnClick}>
          {tcpa ? tcpa : null}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClosed}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default App;
